<template>
  <div class="container">
    <h1>This is Terms and Conditions</h1>
    <p>Under construction</p>
    <div class="btn-container">
      <button @click="this.$router.go(-1)" class="btn btn-success">Go Back</button>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        
      }
    },
    created() {
    },
    methods: {
    },
  }
</script>

<style scoped>
</style>